var defineWellKnownSymbol = require('../internals/define-well-known-symbol');

// `Symbol.metadataKey` well-known symbol
// https://github.com/tc39/proposal-decorator-metadata
defineWellKnownSymbol('metadataKey');



//////////////////
// WEBPACK FOOTER
// ./node_modules/core-js-pure/modules/esnext.symbol.metadata-key.js
// module id = 459
// module chunks = 0 1